export const modalDialogEventType = {
    'modal-dialog-close': 'modal-dialog-close',
    'modal-dialog-open': 'modal-dialog-open'
};
export class ModalDialogEvent extends Event {
    constructor(type) {
        super(type, { cancelable: true });
    }
}
//# sourceMappingURL=modal-dialog-event.js.map